import script from "./SetupCustomersStep.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupCustomersStep.vue?vue&type=script&setup=true&lang=js"

import "./SetupCustomersStep.vue?vue&type=style&index=0&id=2ff7d1b5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ff7d1b5"]])

export default __exports__

/* vue-cli-plugin-import-components */

import GlowFrame from "@/components/catering/GlowFrame.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
import SwooshArrow from "@/components/catering/SwooshArrow.vue";
script.components = Object.assign({}, { GlowFrame, NeueButton, SwooshArrow }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { GlowFrame, NeueButton, SwooshArrow }, script.__o.components);}